/**
 * bubblemachine — the skin.
 *
 * Dials (from DESIGN.md ## Dials — keep these in sync):
 *   VARIANCE  3 / 5   one signature — bubbles — carried everywhere
 *   MOTION    3 / 5   the subject is a machine that moves; a still page lies
 *   DENSITY   2 / 5   generous whitespace, one idea per screen
 *
 * This file is the whole contract between the project and core. Everything
 * project-specific is reachable from here; nothing project-specific lives
 * anywhere else.
 *
 * What the contract refuses, and why (core validates at build AND at mount):
 *   - removing the footer            brand presence and the privacy link
 *   - public links to admin routes   disclosure risk, BRIEF §6
 *   - overriding the analytics beacon  the no-consent-banner legal position
 *   - bypassing the SEO head         crawlability and the Core Web Vitals budget
 *   - opting out of reduced motion   accessibility
 */

import { defineSkin } from '@remidus/web-core'

import blockSpecs from './block-specs'
import blocks from './blocks'
import layout from './layout'
import motion from './motion'
import scene from './scene'

// Publish this skin's block fields for edit mode.
//
// Edit mode on a public page is started by a bootstrap the API writes, and that
// bootstrap cannot know a project's manifest: the manifest is project
// TypeScript and the public page deliberately loads no admin code. Without this
// every project block reads "This block has no options" when you click it in
// place, which is every field this skin defines, missing.
//
// It is data — block types, labels, field keys, help text. No admin, platform
// or auth URL among them, so `scripts/check-public-bundle.mjs` is unaffected,
// and it is a couple of kilobytes for every visitor to make the page editable
// by the people who own it.
if (typeof window !== 'undefined') {
  ;(window as unknown as { __REMIDUS_BLOCKS__?: unknown }).__REMIDUS_BLOCKS__ = blockSpecs.blocks
}

export default defineSkin({
  name: 'bubblemachine',

  dials: { variance: 3, motion: 3, density: 2 },

  scene,
  motion,
  blocks,
  ...(layout ? { layout } : {}),

  // Extra footer and header links. They may not point at admin surfaces —
  // the contract checks, and `make check` greps the built bundle as well.
  footerLinks: [],
  headerLinks: [],
})
